/*
 * @Description:
 * @Author: Mankeung
 * @Date: 2021-07-17 20:42:45
 * @LastEditors: Mankeung
 * @LastEditTime: 2021-07-20 16:30:10
 */
export default [
    {
        path: "VoucherList",
        name: "VOUCHER_LIST",
        meta: {
            title: "券事件列表",
            icon: "",
            cache:'showCache',
            isNav: true,
        },
        component: () =>
            import ("@/views/Voucher/VoucherList.vue"),
    },
    {
        path: "RelatedSecurities",
        name: "RELATED_SECURITIES",
        meta: {
            title: "券列表",
            icon: "",
            cache:'',
            isNav: true,
        },
        component: () =>
            import ("@/views/Voucher/RelatedSecurities.vue"),
    },
    {
        path: "VipVoucher",
        name: "VIP_VOUCHER",
        meta: {
            title: "会员券绑定",
            icon: "",
            cache:'',
            isNav: true,
        },
        component: () =>
            import ("@/views/Voucher/VipVoucher.vue"),
    },
]
